import logo from "../assets/res/logo_infinite.svg";
import searchIcon from "../assets/res/search.svg";

const PageHeader = ({ onSearchClick }) => (
  <div className="flex flex-row justify-between items-center p-4 rounded-b-xl shadow-md">
    <div className="flex flex-row items-center">
      <img src={logo} width="40" height="40" alt="Infinite Mod" />
      <h1 className="ml-2 pressStart text-2xl tracking-wider bg-gradient-to-r from-white to-white bg-clip-text text-transparent">
        MOD
      </h1>
    </div>
    <div className="relative rounded-3xl">
      <div className="absolute -inset-1 bg-gradient-to-r from-yellow-500 via-orange-600 to-red-600 opacity-95 blur rounded-3xl" />
      <div className="relative flex rounded-3xl items-center justify-center bg-slate-900 text-slate-300">
        <div
          className="flex flex-row justify-center items-center rounded-3xl bg-dark-blue px-[12px] py-[6px]"
          onClick={onSearchClick}
        >
          <div className="flex flex-wrap flex-col place-items-center">
            <img src={searchIcon} width="24" height="24" alt="Search" />
          </div>
          <div className="text-white ml-2 semiBold">Search</div>
        </div>
      </div>
    </div>
  </div>
);

export default PageHeader;
